import { h, p as proxyCustomElement, H, c as createEvent, F as Fragment, a as Host } from './index.js';
import { k as konsole } from './p-YbMWREgz.js';
import { C as CELL_CLASS_MENU, g as getColumnStyle, a as CELL_CLASS } from './p-Cma-DzNY.js';
import { d as defineCustomElement$i } from './p-Cd2X-6KG.js';
import { d as defineCustomElement$h } from './p-BedvZv52.js';
import { d as defineCustomElement$g } from './p-BN9xIVU9.js';
import { d as defineCustomElement$f } from './p-D-k_i6-R.js';
import { d as defineCustomElement$e } from './p-DZKBv4tL.js';
import { d as defineCustomElement$d } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$c } from './p-BVCTlSQE.js';
import { d as defineCustomElement$b } from './p-D4xpFZtu.js';
import { d as defineCustomElement$a } from './p-BkDQJ61k.js';
import { d as defineCustomElement$9 } from './p-Cy8qWWQl.js';
import { d as defineCustomElement$8 } from './p-DLWyhg_S.js';
import { d as defineCustomElement$7 } from './p-DaiIyqo3.js';
import { d as defineCustomElement$6 } from './p-DE-WBrSS.js';
import { d as defineCustomElement$5 } from './p-Dg3i2AwD.js';
import { d as defineCustomElement$4 } from './p-rSqjxn-v.js';
import { d as defineCustomElement$3 } from './p-aqq22Qbe.js';
import { d as defineCustomElement$2 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$1 } from './p-QtR5VUMp.js';

// biome-ignore lint/correctness/noUnusedImports: needed for Stencil
const Anchor = ({ children, ...props }) => {
    return (h("a", { ...props,
        // biome-ignore lint/a11y/useValidAnchor: we explicitly need to override the anchor's click behavior
        onClick: (e) => {
            if (props.onClick) {
                return props.onClick(e);
            }
            if (props.disabled) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        } }, children.map((child) => renderComponentDef(child))));
};
const Text = ({ label, description, title, icon, }) => {
    const labelNode = (h("span", { class: "label", title: title ?? label }, label));
    let innerContent = labelNode;
    if (description) {
        innerContent = (h("div", { class: "with-description" }, labelNode, h("span", { class: "description" }, description)));
    }
    if (icon) {
        innerContent = (h("div", { class: "with-icon" }, h("wui-icon", { name: icon }), innerContent));
    }
    return innerContent;
};
const Thumbnail = (props) => {
    return h("wui-thumbnail", { ...props });
};
const CodeSnippet = (props) => {
    return h("wui-code-snippet", { ...props });
};
const COMPONENTS = {
    anchor: Anchor,
    text: Text,
    'wui-thumbnail': Thumbnail,
    'wui-code-snippet': CodeSnippet,
};

const renderComponentDef = ({ component, props }, extraProps) => {
    if (!(component in COMPONENTS)) {
        throw new Error(`Unknown component ${component}. Supported: ${Object.keys(COMPONENTS).join(', ')}.`);
    }
    const componentFn = COMPONENTS[component];
    return componentFn(
    // No need for type-safety here, it would be cumbersome to implement
    { ...props, ...extraProps });
};

const tableRowCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:block;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;min-width:100%;width:0}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.container{background-color:var(--jw-theme-surface-tile-bg-color);position:relative}.state-container{display:none;height:100%;top:0;width:100%}.state,.state-container{bottom:0;left:0;pointer-events:none;position:absolute;right:0}.state{align-items:center;display:flex;justify-content:center;opacity:0;text-align:center;top:42px;transition:opacity .3s ease;z-index:1}.state p{max-width:50ch;white-space:pre-line}.state-title{font-size:15px!important}.state-description{font-size:13px!important;margin:0!important}:host([selectable]) wui-skeleton-line{left:32px}:host([error-type=error]) wui-table-row,:host([is-empty]) wui-table-row{opacity:.1;pointer-events:none}:host([error-type=error]) .state-container,:host([is-empty]) .state-container{display:block}:host([error-type=error]) wui-table-row:not(:nth-child(n+1):nth-child(-n+11)),:host([is-empty]) wui-table-row:not(:nth-child(n+1):nth-child(-n+11)){display:none}:host([error-type=error]) .state.error{opacity:1;pointer-events:all}:host([is-empty]:not([error-type=error])) wui-table-header-row{opacity:.1}:host([is-empty]:not([error-type=error])) .state.empty{opacity:1;pointer-events:all}:host([loading]) .cell{opacity:0}:host{display:flex;flex-direction:row;flex-wrap:wrap;position:relative}:host:after{background-color:var(--jw-theme-surface-border-border-color);bottom:0;content:\"\";height:1px;left:0;position:absolute;right:0;width:100%}.cell{color:var(--jw-theme-surface-text-default-color);flex:1 1 0;height:100%;margin:0 .5rem;min-width:0}.cell.checkbox{display:flex;flex-grow:0;justify-content:center;line-height:0;margin:0;max-width:32px;min-width:32px}.cell.checkbox wui-check-input[checked],.cell.checkbox wui-check-input[indeterminate]{opacity:1!important}.cell[data-sort-type=number]{justify-content:flex-end}.cell__menu{align-items:center;display:inline-flex;margin:0 .5rem;padding:0;width:2rem}:host{--hover-actions-bg:var(--jw-theme-surface-tile-bg-color);animation:u85yoha .4s ease;background-color:var(--jw-theme-surface-tile-bg-color);opacity:1;transition:height .35s ease}@keyframes u85yoha{0%{opacity:0}to{opacity:1}}.cell{align-items:center;display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;letter-spacing:-.0004em;line-height:1.25rem;position:relative;transition:padding .35s ease,opacity .35s ease}.cell span:not(.description){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cell>a{align-items:center;color:inherit;display:flex;flex:1;gap:.75rem;height:100%;overflow:hidden;width:100%}.cell>a,.cell>a:hover{text-decoration:none}.cell>a:not([disabled]) span.label{color:var(--jw-theme-system-secondary-default-color);text-decoration:underline}.cell>a:not([disabled]):hover span.label{color:var(--jw-theme-system-secondary-hover-color)}.cell>a:not([disabled]):active span.label{color:var(--jw-theme-system-secondary-active-color)}.cell>a[disabled]{cursor:not-allowed}.cell div.with-description{display:flex;flex-direction:column;gap:.125rem;overflow:hidden}.cell div.with-description span.description{color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}.cell div.with-icon{align-items:center;display:flex;gap:.75rem}.cell[data-col=anchor-with-icon-and-text] div.with-icon,.cell[data-col=text-with-icon-and-description] div.with-icon{align-items:flex-start}.cell[data-col=anchor-with-icon-and-text] div.with-icon wui-icon,.cell[data-col=text-with-icon-and-description] div.with-icon wui-icon{margin:.125rem 0}.hover-element{opacity:0;transition:opacity .15s ease}.hover-actions{align-items:center;animation:u85yohz .35s ease forwards;background:linear-gradient(to right,#0000 0,var(--hover-actions-bg) 48px);bottom:1px;display:flex;justify-content:flex-end;padding-left:72px;padding-right:12px;position:absolute;right:0;top:0;z-index:var(--jw-z-index-hover)}@keyframes u85yohz{0%{opacity:0;transform:translateX(2px)}to{opacity:1;transform:translateX(0)}}:host(:not(:hover)) .hover-actions{display:none}wui-thumbnail{flex:none;transition:width .35s ease,height .35s ease}wui-skeleton-line{left:0;position:absolute;top:calc(50% - 8px);z-index:1}:host([density=sm]){height:2rem;padding:.5rem 0}:host([density=sm]) .cell wui-thumbnail{height:0!important;width:0!important}:host([density=sm]) .cell span.description{display:none}:host([density=md]){height:3rem;padding:.5rem 0}:host([density=md]) .cell wui-thumbnail{height:2rem!important;width:3rem!important}:host([density=md]) .cell span.description{display:none}:host([density=lg]){height:4.5rem;padding:.5rem 0}:host([density=lg]) .cell wui-thumbnail{height:3.5rem!important;width:6rem!important}:host([density=lg]) .cell span.description{display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical}:host([density=xl]){height:7.5rem;padding:1rem 0}:host([density=xl]) .cell wui-thumbnail{height:5.5rem!important;width:9rem!important}:host([density=xl]) .cell span.description{display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:4;-webkit-box-orient:vertical}:host([data-selected]){background-color:var(--jw-theme-surface-item-active-bg-color)}:host(:not([disabled]):not([loading]):hover){background-color:var(--jw-theme-surface-item-hover-bg-color)}:host(:not([disabled]):not([loading]):hover) .hover-element{opacity:1}:host([disabled]) .hover-actions,:host([loading]) .hover-actions,:host([rows-selected]) .hover-actions{display:none}";

const WuiTableRow = /*@__PURE__*/ proxyCustomElement(class WuiTableRow extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.selectRecord = createEvent(this, "selectRecord", 3);
        this.visibleColumns = [];
        this.selectable = false;
        this.rowsSelected = true;
    }
    getHoverActions(record) {
        if (this.hoverActions) {
            const ret = this.hoverActions(record);
            if (Array.isArray(ret)) {
                return (h("wui-layout", { type: "button-group" }, ret.map((child, idx) => {
                    return h("wui-button", { key: idx, ...child.props });
                })));
            }
            return (h("wui-more-menu", { icon: "dots" }, h("wui-list", null, ret.props.children.map((child) => {
                switch (child.component) {
                    case 'wui-list-item':
                        return h("wui-list-item", { ...child.props });
                    case 'wui-list-item-header':
                        return h("wui-list-item-header", { ...child.props });
                    case 'wui-list-item-divider':
                        return h("wui-list-item-divider", { ...child.props });
                }
            }))));
        }
        konsole.warn.deprecation(this, 'hoverActionsTemplate', 'Switch to `hoverActions`.');
        const hoverActionTemplateRet = this.hoverActionsTemplate && this.record
            ? this.hoverActionsTemplate(this.record, h)
            : null;
        if (typeof hoverActionTemplateRet === 'function') {
            // Pass inner div with `ref` to prevent the parent div from being hijacked
            return h("div", { ref: (el) => hoverActionTemplateRet(el, this.idx) });
        }
        if (hoverActionTemplateRet) {
            return h(Fragment, null, hoverActionTemplateRet);
        }
    }
    renderLabel(label, title) {
        return (h("span", { class: "label", title: title ?? label }, label));
    }
    renderCustomCellContent(column) {
        if (typeof column.render !== 'function') {
            return;
        }
        const ret = column.render(this.record);
        if (!ret) {
            return;
        }
        if (typeof ret === 'string') {
            return this.renderLabel(ret);
        }
        return renderComponentDef(ret, { disabled: this.disabled });
    }
    renderCellContent(column, cellProps) {
        let inner = null;
        if (typeof column.render === 'function') {
            inner = this.renderCustomCellContent(column);
        }
        else {
            const stringValue = this.record && column.name && column.name in this.record.data && this.record.data[column.name]
                ? String(this.record.data[column.name])
                : '';
            inner = this.renderLabel(stringValue);
        }
        return (h("div", { key: column.name, ...cellProps }, inner));
    }
    render() {
        const hoverActions = this.record && this.getHoverActions(this.record);
        return (h(Host, { key: '0ececbbf650625b29265d94531e57d0b62c58b27', "data-selected": this.record?.isSelected }, this.loading && h("wui-skeleton-line", { key: '4bc18f1c4986b63e52d90c67ba17c55939ba0cc1', variableWidth: "nested" }), hoverActions && h("div", { key: '78a0804f228cbbce1dbfb3234faea91d921debb8', class: "hover-actions" }, hoverActions), this.selectable && (h("div", { key: 'b8613af3c680521c2b0f0b9668a1b34d641b2b04', class: `${CELL_CLASS} checkbox` }, h("wui-check-input", { key: '5703d2f7dd5acd5652c16b9872f3e1c6d0a651c9', class: "hover-element", disabled: this.disabled || !this.record || this.record.selectable === false, checked: this.record?.isSelected, onInput: () => this.selectRecord.emit(String(this.record?.key)) }))), this.visibleColumns?.map((column) => {
            const columnName = String(column.name);
            const cellProps = {
                className: CELL_CLASS,
                'data-col': columnName.replace(/\./gm, '-'),
                'data-sort-type': column.sortType,
                style: getColumnStyle(column),
            };
            // If a custom template was passed
            if (this.columnTemplates && columnName in this.columnTemplates) {
                const customTemplateFn = this.columnTemplates[columnName];
                // Only call template function when we have a record
                const customTemplateRet = this.record && customTemplateFn ? customTemplateFn(this.record, h) : '';
                if (typeof customTemplateRet === 'function') {
                    // Return a placeholder div, and pass a reference to its DOM element
                    // to the returned function. This function may then manually
                    // perform any dom mutations on our cell's div.
                    return h("div", { ...cellProps, key: `${columnName}.custom`, ref: (el) => customTemplateRet(el, this.idx) });
                }
                // Render the returned string or Stencil VNode
                return (h("div", { key: columnName, ...cellProps }, customTemplateRet));
            }
            return this.renderCellContent(column, cellProps);
        }), this.record && this.rowMenuItems ? (h("div", { class: CELL_CLASS_MENU }, !this.loading && (h("wui-more-menu", { icon: "dots", closeOnClickInside: true }, h("wui-list", null, this.rowMenuItems(this.record).map((item) => {
            return h("wui-list-item", { ...item });
        })))))) : null));
    }
    static get style() { return tableRowCss; }
}, [257, "wui-table-row", {
        "visibleColumns": [16, "visible-columns"],
        "record": [16],
        "columnTemplates": [16, "column-templates"],
        "hoverActionsTemplate": [16, "hover-actions-template"],
        "hoverActions": [16, "hover-actions"],
        "selectable": [4],
        "rowsSelected": [516, "rows-selected"],
        "loading": [516],
        "disabled": [516],
        "idx": [2],
        "density": [513],
        "rowMenuItems": [16, "row-menu-items"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-table-row", "wui-box", "wui-button", "wui-check-input", "wui-divider", "wui-form-field", "wui-icon", "wui-layout", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-loader", "wui-menu-pane", "wui-more-menu", "wui-skeleton-line", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-table-row":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTableRow);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-more-menu":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-skeleton-line":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiTableRow as W, defineCustomElement as d };
